import styled from 'styled-components/macro';
import { DefaultError500BG } from '@yme/assets/images';
import { colorCoreBlack700, colorCoreWhite1000, HERO_SECTION_BACKGROUND_SECOND, } from '@yme/tokens/colors';
import { INDENT } from '@yme/tokens/sizes';
import { UbuntuFontFamily } from '@yme/tokens/typography';
import { Z_INDEX } from '@yme/tokens/zindex';
export const WrapperStyled = styled.div `
  width: 100%;
  height: 100vh;

  position: relative;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}

  color: ${colorCoreWhite1000};
  ${UbuntuFontFamily};

  @media (max-width: 767.98px) {
    justify-content: flex-start;

    background-color: ${colorCoreBlack700};
  }
`;
export const BackgroundStyled = styled.div `
  position: absolute;
  left: 0;
  top: 0;
  z-index: ${Z_INDEX.levelNegative1};

  width: 100%;
  height: 100%;

  background: ${HERO_SECTION_BACKGROUND_SECOND}, url(${DefaultError500BG});
  background-size: cover;
  background-position: 50%;

  @media (max-width: 767.98px) {
    display: none;
  }
`;
export const HeaderStyled = styled.header `
  background-color: ${colorCoreWhite1000};
  padding: 0 ${INDENT.xl};

  display: flex;
  align-items: center;
  height: 80px;

  @media (max-width: 767.98px) {
    padding: 0 ${INDENT.xs};
  }

  @media (min-width: 768px) and (max-width: 1024.98px) {
    padding: 0 ${INDENT.sm};
  }
`;
export const LogoStyled = styled.div `
  cursor: pointer;
`;
export const ContentStyled = styled.div `
  margin-bottom: 120px;

  ${({ isRightToLeft }) => isRightToLeft ? `padding-right:${INDENT.xl}` : `padding-left:${INDENT.xl}`};

  @media (max-width: 767.98px) {
    padding: 0;
    margin-bottom: 0;
  }

  @media (min-width: 768px) and (max-width: 1024.98px) {
    padding: 0 ${INDENT.sm};

    margin-bottom: 40px;
  }

  @media (min-width: 1025px) {
    max-width: calc(50% - 60px);
  }
`;
export const ContentHeaderStyled = styled.div `
  @media (max-width: 767.98px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    height: 202px;
    padding: 0 ${INDENT.xs} ${INDENT.xs};
    margin-bottom: 24px;

    background: url(${DefaultError500BG});
    background-size: cover;
    background-position: 50%;
  }
`;
export const ContentDescriptionStyled = styled.div `
  @media (max-width: 767.98px) {
    padding: 0 ${INDENT.xs};
  }
`;
